export default __webpack_public_path__ + "static/media/oda-workplace-insights-image.b87451b8.jpg";